<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-header">
        <h3>Upload Contract Files</h3>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <p>
              Upload at least <span class="fw-bolder">ONE(1)</span> file to
              continue. Maximum of 15 files.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <app-file-upload-file-display
              [removeFileButtonText]="'DELETE'"
              [hideSelectFileButton]="true"
              [Files]="Files"
              (FileEvent)="fileUpload($event)"
              (removeFileEvent)="removeFile($event)"
            ></app-file-upload-file-display>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row w-100 justify-content-end">
          <!-- <div class="col-md-6">
                        <button class="btn btn-secondary" (click)="close()">Cancel</button>
                    </div> -->
          <div class="col-md-6">
            <button class="btn btn-primary" (click)="continue()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
